import jQuery from 'jquery'
import localStorage from '@/api/localStorage'
import datePicker from 'vue-bootstrap-datetimepicker'
import $ from 'jquery'
import { SITE_URL } from '@/api/config'
import 'eonasdan-bootstrap-datetimepicker/build/css/bootstrap-datetimepicker.css'
import { mapActions, mapGetters } from 'vuex'
import { urlParam } from '@/helper'
import {
  FETCH_SEARCH_FILTERS,
  SET_ANALYST_STATE,
  SET_TIME_STATE,
  SET_RESEARCH_TYPE,
  SET_SEARCH_RESULT_LOADING,
  LOAD_MORE_RESULT,
  SET_CURRENT_PAGE,
  SET_LOAD_MORE_STATUS,
  SET_CUSTOM_DATE,
  SET_SEARCH_KEY,
  SET_ORDER_BY,
  LOAD_SEARCH_RESULT,
  SET_LOCALSTORAGE_SEARCH_FILTER,
  SET_SEARCH_SYMBOL,
  SET_ENTITLEMENT_VALUE,
  GET_EXTERNALURL_SEARCH
} from '@/store/actions.type'
import searchResultPreview from '@/components/search-result-preview'
import ThePlaceHolder from '@/components/ThePlaceHolder'
import searchEntitledModal from '@/components/searchEntitledModal.vue'
export default {
  name: 'searchresults',
  created() {
    this.fetchfilter(),
    this.onloadgetresult(),
    window.addEventListener( 'scroll', this.handleScroll ),
    this.settingHeight()
  },
  components: {
    datePicker,
    searchResultPreview,
    ThePlaceHolder,
    searchEntitledModal
  },
  data() {
    return {
      videoiframe: '',
      category: urlParam.entitlementcategory
        ? decodeURI( urlParam.entitlementcategory )
        : '',
      types: /(\.|\/)(mp3|mp4)$/i,
      heightStyle: '',
      startdate: '',
      enddate: '',
      theme: this.$store.state.appsetting.theme,
      config: {
        format: 'YYYY-MM-DD',
        useCurrent: false
      },
      limit: 10,
      reserchtypeopt: '',
      reserchtype: [],
      searchresult: '',
      postcount: 0,
      currentpage: 1,
      loadmore: false,
      filtersLoading: false,
      searchResultsLoading: false,
      filters: {},
      vimeoUrl: '',
      specificDatesShow: false,
      seletedAnalyst: 'Any Analyst',
      startTime: this.$store.state.searchresult.searchfilters.start_time,
      endTime: this.$store.state.searchresult.searchfilters.end_time,
      seletedAnalystDate: 'Any Time',
      searchkey: '',
      seletedAnalystD: '',
      selectedcatType: this.$store.state.searchresult.searchfilters.category
        ? this.$store.state.searchresult.searchfilters.category
        : '',
      searchsymbolState:
        this.$store.state.searchresult.searchfilters.symbol == '',
      searchsymbol: this.$store.state.searchresult.searchfilters.symbol,
      anytime: [
        {
          value: 'clear',
          text: 'Any Time'
        },
        {
          value: '1-week',
          text: 'Within 1 week'
        },
        {
          value: '1-month',
          text: 'Within 1 month'
        },
        {
          value: '3-months',
          text: 'Within 3 months'
        },
        {
          value: '6-months',
          text: 'Within 6 months'
        },
        {
          value: '1-year',
          text: 'Within 1 year'
        },
        {
          value: 'specificdates',
          text: 'Specific Dates'
        }
      ],
      time: 'clear',
      orderby: [
        {
          value: 'desc',
          text: 'Most recent'
        },
        {
          value: 'asc',
          text: 'Least recent'
        }
      ],
      sort: 'desc'
    }
  },
  computed: {
    searchfilters() {
      if ( this.$store.state.searchresult.searchfilters.time ) {
        this.time = this.$store.state.searchresult.searchfilters.time
      }

      this.reserchtype = this.$store.state.searchresult.filters.categories

      return this.$store.state.searchresult.filters
    },

    fetchsearchResult() {
      function positionIe() {
        var positiononchange = $( '#reserchtype' ).on( 'change', function () {
          positiononchange.find( 'option:selected' ).prependTo( positiononchange )
        } )
      }
      $( document ).ready( function () {
        if ( ( /MSIE \d|Trident.*rv:/.test( navigator.userAgent ) ) || ( /^((?!chrome|android).)*safari/i.test( navigator.userAgent ) ) ) {
          positionIe()
          $( '#reserchtype' ).change()
        }
      } )
      if (
        this.$store.state.searchresult.searchfilters.time == 'clear' ||
        this.$store.state.searchresult.searchfilters.time == ''
      ) {
        this.seletedAnalystDate = 'Any Time'
      } else {
        this.seletedAnalystDate = this.$store.state.searchresult.searchfilters.time
        if ( this.seletedAnalystDate ) {
          var self = this.seletedAnalystDate
          var analystDate = this.anytime.filter( function ( values ) {
            return values.value === self
          } )
          this.seletedAnalystDate = analystDate[0].text
        } else {
          this.seletedAnalystDate = 'Specific Dates'
        }
      }
      if ( this.$store.state.searchresult.searchfilters.analyst == '' ) {
        this.seletedAnalyst = 'Any Analyst'
      }

      this.sort = this.$store.state.searchresult.searchfilters.sort

      this.searchkey = this.$store.state.searchresult.searchfilters.key
      this.postcount = this.$store.state.searchresult.searchresult.postcount

      this.searchsymbolState =
        this.$store.state.searchresult.searchfilters.symbol == ''
      this.searchsymbol = this.$store.state.searchresult.searchfilters.symbol
      return this.$store.state.searchresult.searchresult.posts
    },
    searchpostcounts() {
      if ( !this.$store.state.searchresult.entitlementcheck ) {
        const elem = this.$refs.entlitmentPopup
        elem.click()
      }
      this.selectedcatType = this.$store.state.searchresult.searchfilters.category
      this.postcount = this.$store.state.searchresult.searchresult.postcount
      return this.$store.state.searchresult.searchresult.postcount
    },
    changeLoadingStatus() {
      this.searchResultsLoading = this.$store.state.searchresult.searchresultloading
      return this.$store.state.searchresult.searchresultloading
    },
    setLoadmoreStatus() {
      this.loadmore = this.$store.state.searchresult.loadmore
      return this.$store.state.searchresult.loadmore
    }
  },
  methods: {
    ...mapActions( {
      onloadresults: LOAD_SEARCH_RESULT,
      fetchsearchfilters: FETCH_SEARCH_FILTERS,
      setanalystinSearchfilter: SET_ANALYST_STATE,
      settimeinSearchfilter: SET_TIME_STATE,
      setresearchtypeSearchfilter: SET_RESEARCH_TYPE,
      setsearchloading: SET_SEARCH_RESULT_LOADING,
      setcurrentpage: SET_CURRENT_PAGE,
      setcustomdate: SET_CUSTOM_DATE,
      setloadmore: SET_LOAD_MORE_STATUS,
      setsearchkey: SET_SEARCH_KEY,
      loadmoreposts: LOAD_MORE_RESULT,
      orderbysearch: SET_ORDER_BY,
      setlocalstoragetostore: SET_LOCALSTORAGE_SEARCH_FILTER,
      setsymbol: SET_SEARCH_SYMBOL,
      getExternalUrlSearch: GET_EXTERNALURL_SEARCH
    } ),
    ...mapGetters( [
      'searchResultLoading',
      'searchstate',
      'activetabid',
      'searchEntitledCategory'
    ] ),
    selectAnlyst: function ( anlystobj ) {
      window.scrollTo( 0, 0 )
      this.currentpage = 1
      var searchkey = $( '#searchKey' ).val()
      this.setsearchkey( searchkey )
      this.setcurrentpage( this.currentpage )
      this.setanalystinSearchfilter( anlystobj.id )
      this.seletedAnalyst = anlystobj.name
    },
    searchEntitledModalpopup( cat ) {
      if ( this.$store.state.auth.user.username ) {
        digitalData['entitledLockLink'] = cat
        _satellite.track( 'entitledContentPopUp' )
      }
      this.category = cat
    },
    removesymbol() {
      this.currentpage = 1
      this.setcurrentpage( this.currentpage )
      this.setsymbol( '' )
    },
    selectTime: function ( value, text ) {
      window.scrollTo( 0, 0 )
      this.seletedAnalystDate = text
      var searchkey = $( '#searchKey' ).val()
      this.setsearchkey( searchkey )

      if ( value == 'specificdates' ) {
        this.specificDatesShow = true
      } else {
        jQuery( '#start_date' ).val( '' )
        jQuery( '#enddate' ).val( '' )
        this.specificDatesShow = false
        var customDateobj = {}
        customDateobj['start_time'] = ''
        customDateobj['end_time'] = ''
        this.setcustomdate( customDateobj )
        this.resetFiltersValues()
        this.settimeinSearchfilter( value )
      }
    },
    customDatesearch: function () {
      var searchkey = $( '#searchKey' ).val()
      this.setsearchkey( searchkey )
      if ( jQuery( '#start_date' ).val() === '' ) {
        jQuery( '#start_date' ).css( 'border', '1px solid red' )
      } else if ( jQuery( '#enddate' ).val() === '' ) {
        jQuery( '#start_date' ).css( 'border', '1px solid #ced4da' )
        jQuery( '#enddate' ).css( 'border', '1px solid red' )
      } else {
        jQuery( '#enddate' ).css( 'border', '1px solid #ced4da' )
        var selectTimevalue = jQuery( '#selectAnyTime' ).val()
        var customDateobj = {}
        customDateobj['start_time'] = jQuery( '#start_date' ).val()
        customDateobj['end_time'] = jQuery( '#enddate' ).val()
        this.resetFiltersValues()
        this.setcustomdate( customDateobj )
        this.settimeinSearchfilter( selectTimevalue )
        // jQuery('#start_date').val('')
        // jQuery('#enddate').val('')
        this.specificDatesShow = false
      }
    },
    onloadgetresult: function () {
      var searchfilter = JSON.parse( localStorage.getlocalStorage( 'searchTab' ) )
      // this.setlocalstoragetostore(JSON.parse(searchfilter))
      if ( urlParam.tab == 'search' ) {
        var localAnalyst = searchfilter ? searchfilter.analyst : ''
        var localTime = searchfilter ? searchfilter.time : ''
        var localStartTime = searchfilter ? searchfilter.start_time : ''
        var localEndTime = searchfilter ? searchfilter.end_time : ''
        var localCategory = searchfilter ? searchfilter.category : ''
        if ( localStorage.getlocalStorage( 'login' ) == null ) {
          localAnalyst = ''
          localTime = ''
          localStartTime = ''
          localEndTime = ''
          localCategory = ''
        }
        var searchfilters = {
          tab: urlParam.tab,
          key: urlParam.key ? urlParam.key : '',
          symbol: urlParam.symbol ? urlParam.symbol : '',
          type: urlParam.type ? urlParam.type : '',
          analyst: urlParam.analystid ? urlParam.analystid : localAnalyst,
          time: urlParam.time ? urlParam.time : localTime,
          start_time: urlParam.start_time
            ? urlParam.start_time
            : localStartTime,
          end_time: urlParam.end_time ? urlParam.end_time : localEndTime,
          sort: urlParam.sort ? urlParam.sort : 'desc',
          is_filter: urlParam.is_filter ? urlParam.is_filter : '',
          category: urlParam.category ? urlParam.category : localCategory,
          search: urlParam.search ? urlParam.search : '',
          currentpage: 1
        }
        this.getExternalUrlSearch( searchfilters )
      } else {
        this.onloadresults()
      }
    },
    submitSearch: function () {
      this.currentpage = 1
      var searchkey = this.searchkey
      this.resetFiltersValues()
      this.setsearchkey( searchkey )
      digitalData['searchQuery'] = searchkey
      _satellite.track( 'researchSearchResults' )
    },
    getsearchLoading: function () {
      return this.searchResultLoading()
    },
    resetFiltersValues: function () {
      this.currentpage = 1
      this.setcurrentpage( this.currentpage )
      this.setsearchloading( true )
    },
    selectOrderby: function () {
      this.currentpage = 1
      this.setcurrentpage( this.currentpage )
      this.resetFiltersValues()
      var researchtype = jQuery( '#rvorderby' ).val()
      this.orderbysearch( researchtype )
    },
    selectReserchType: function () {
      var searchkey = $( '#searchKey' ).val()
      this.setsearchkey( searchkey )
      window.scrollTo( 0, 0 )
      this.currentpage = 1
      this.setcurrentpage( this.currentpage )
      var researchtype = jQuery( '#reserchtype' ).val()
      if ( this.$store.state.searchresult.filters.entitlement_filters[researchtype] === 'undefined' ||
          this.$store.state.searchresult.filters.entitlement_filters[researchtype] === false
      ) {
        var researchtype = jQuery( '#reserchtype option:selected' ).html()
        var searchTypeValue = JSON.parse(
          window.localStorage.getItem( 'searchTab' )
        )
        this.setresearchtypeSearchfilter( searchTypeValue['category'] )
        this.searchEntitledModalpopup( researchtype )
        const elem = this.$refs.entlitmentPopup
        elem.click()
      } else {
        this.resetFiltersValues()
        this.setresearchtypeSearchfilter( researchtype )
      }

      /* if (
        navigator.userAgent.match( /(MSIE)/ ) &&
        navigator.userAgent.match( /(.NET CLR)/ )
      ) {
        this.resetFiltersValues()
        this.setresearchtypeSearchfilter( researchtype )
      } else {
        // this.searchEntitledCategoryresearchtype();
        if (
          this.$store.state.searchresult.filters.entitlement_filters[
            researchtype
          ] == 'undefined' ||
          this.$store.state.searchresult.filters.entitlement_filters[
            researchtype
          ] == false
        ) {
          var researchtype = jQuery( '#reserchtype option:selected' ).html()

          this.searchEntitledModalpopup( researchtype )
          const elem = this.$refs.entlitmentPopup
          elem.click()
        } else {
          this.resetFiltersValues()
          this.setresearchtypeSearchfilter( researchtype )
        }
      }
        */
    },

    closeSelectOpt: function () {
      this.startTime = this.$store.state.searchresult.searchfilters.start_time
      this.endTime = this.$store.state.searchresult.searchfilters.end_time
      jQuery( '#start_date' ).val( this.startTime )
      jQuery( '#enddate' ).val( this.endTime )
      this.specificDatesShow = false
    },
    async fetchfilter() {
      // console.log(navigator)
      this.filtersLoading = true
      await this.fetchsearchfilters()
      // this.seletedAnalyst = this.$store.state.searchresult.filters.authors

      if ( this.$store.state.searchresult.searchfilters.analyst ) {
        for (
          var i = 0;
          i < this.$store.state.searchresult.filters.authors.length;
          i++
        ) {
          if (
            this.$store.state.searchresult.filters.authors[i].id ==
            this.$store.state.searchresult.searchfilters.analyst
          ) {
            this.seletedAnalyst = this.$store.state.searchresult.filters.authors[
              i
            ].name
            break
          }
        }
      }
      if ( this.$store.state.searchresult.searchfilters.key !== '' ) {
        this.searchkey = this.$store.state.searchresult.searchfilters.key
      }
      if ( this.$store.state.searchresult.searchfilters.symbol !== '' ) {
        if ( urlParam.tab !== 'search' ) {
          this.searchkey = this.$store.state.searchresult.searchfilters.symbol
        }
      }

      this.filtersLoading = false
    },
    async loadMoreSearchResult() {
      await this.loadmoreposts()
    },
    handleScroll() {
      var scrollTop1, scrollTop2

      scrollTop1 = Math.ceil( document.documentElement.scrollTop )
      scrollTop2 = Math.ceil( document.body.scrollTop )
      // le.log(scrollTop1,scrollTop2,'scrollTop1',navigator.userAgent.search( 'Safari' ),navigator.userAgent.search( 'Chrome' ), navigator.platform == 'MacIntel' )

      if ( this.activetabid() == 'search' || this.activetabid() == 'null' ) {
        var bottomOfWindow = false
        // if( $(window).scrollTop() > $(document).height() - $(window).height() ) {

        var scrollTop, consolevalue

        if (
          navigator.platform == 'MacIntel' ||
          ( navigator.userAgent.search( 'Safari' ) > 0 &&
            navigator.userAgent.search( 'Chrome' ) < 0 )
        ) {
          //   console.log("this is Safari ")
          consolevalue =
            'document.body.scrollTop> window.innerHeight - document.documentElement.offsetHeight'
          scrollTop = Math.ceil( document.documentElement.scrollTop )
        } else {
          //   console.log("other than  is Safari ")
          scrollTop = Math.ceil( document.documentElement.scrollTop )
          consolevalue =
            'document.documentElement.scrollTop window.innerHeight - document.documentElement.offsetHeight'
        }
        //  console.log(scrollTop, window.innerHeight, document.documentElement.offsetHeight)

        if (
          scrollTop + window.innerHeight >=
          document.documentElement.offsetHeight
        ) {
          var bottomOfWindow = true
        }

        // console.log(consolevalue, scrollTop, window.innerHeight, document.documentElement.offsetHeight)

        // console.log('bottomOfWindow ', bottomOfWindow)

        var stateValue = this.searchstate()
        /* console.log(
          bottomOfWindow,
          stateValue.loadmore,
          stateValue.searchresultloading,
          stateValue.searchfilters.currentpage,
          stateValue.searchresult.totalpages
        )
        */
        // console.log( "mohan", bottomOfWindow,!stateValue.loadmore,!stateValue.searchresultloading,stateValue.searchfilters.currentpage,stateValue.searchresult.totalpages)
        if (
          bottomOfWindow &&
          !stateValue.loadmore &&
          !stateValue.searchresultloading &&
          stateValue.searchfilters.currentpage <
            stateValue.searchresult.totalpages
        ) {
          var current_page = stateValue.searchfilters.currentpage + 1
          this.currentpage = current_page
          // console.log('current_page', current_page)
          this.setcurrentpage( current_page )
          this.setloadmore( true )
          this.loadMoreSearchResult()
        }
      }
    },
    settingHeight: function () {
      /*
                                    Setting footer on bottom
                                    */
      if ( this.$store.state.appsetting.theme == 'd' ) {
        var hgt = $( window ).height()
        this.heightStyle = {
          minHeight: hgt + 'px'
        }
      } else if ( this.$store.state.appsetting.theme == 'l' ) {
        var hgt = $( window ).height() - 100
        this.heightStyle = {
          minHeight: hgt + 'px'
        }
      } else {
        var hgt = $( window ).height() - 100
        this.heightStyle = {
          minHeight: hgt + 'px'
        }
      }
    },
    iframeVideo( videoid ) {
      if ( navigator.userAgent.match( /(PANARAY iPad)/ ) ) {
        var videoiframesrc = this.videoURL( videoid, false )
        var videoSrc = $( videoiframesrc ).attr( 'src' )
        this.videoiframe = videoiframesrc
        this.$root.$emit( 'bv::show::modal', 'videomodal' )
        // window.open(videoSrc);
      } else {
        $( '.youTubeVideo' ).attr( 'src', this.vimeoUrl )
        this.videoiframe = this.videoURL( videoid, false )
        this.$root.$emit( 'bv::show::modal', 'videomodal' )
      }
    },
    videoURL: function ( src, feature ) {
      var dec = window.atob( src )
      var outputsrc = JSON.parse( dec )
      var video = ''
      if ( this.types.test( outputsrc ) ) {
        var video =
          '<video width="100%" height="100%" controls><source src="' +
          outputsrc +
          '" type="video/mp4"></video>'
      } else {
        var typesvideo = /^(?:https?:\/\/)?(?:www\.)?youtube\.com\/watch\?(?=.*v=((\w|-){11}))(?:\S+)?$/
        if ( outputsrc.match( typesvideo ) ) {
          var videoUrl = outputsrc.replace( /^.*?(\?|&)(v=([^&]+)).*$/i, '$3' )
          var urlv = 'https://www.youtube.com/embed/' + videoUrl
          var video =
            '<iframe class="youTubeVideo" id="searchVimeo"  width="100%" height="450" src="' +
            urlv +
            '"></iframe>'
        } else {
          var videoID = outputsrc.split( '/' )
          var videoIDVal = videoID[videoID.length - 1]
          if ( feature ) {
            return 'https://player.vimeo.com/video/' + videoIDVal
          }
          // var vimeourl =
          this.vimeoUrl = SITE_URL +
            'research-analyst-morning-call?id=' +
            videoID[videoID.length - 1]

          //	return 'https://player.vimeo.com/video/' + videoID[videoID.length - 1]
          var video =
            '<iframe class="youTubeVideo" id="searchVimeo" width="100%" height="450" src="' +
            this.vimeoUrl +
            '"  frameborder="0" webkitallowfullscreen="" mozallowfullscreen="" allowfullscreen="" data-ready="true"></iframe>'
        }
      }
      return video
    },
    hideModal( id ) {
    //  console.log( 'hideModal' )

      this.$root.$emit( 'bv::hide::modal', id )
      $( '.youTubeVideo' ).attr( 'src', $( '.youTubeVideo' ).attr( 'src' ) )
      $( '.youTubeVideo' ).attr( 'src', '' )
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/searchresults.js